<sc-flex vertical fitHeight stretchContent>
  <div class="no-field-space">
    <form [formGroup]="form">
      <sc-flex>

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export-document.filter.from"></sc-dictionary-label>
          </mat-label>
          <input matInput formControlName="dateFrom" [matDatepicker]="picker1">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <sc-content-spacer></sc-content-spacer>

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export-document.filter.to"></sc-dictionary-label>
          </mat-label>
          <input matInput formControlName="dateUntil" [matDatepicker]="picker2">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <sc-content-spacer></sc-content-spacer>

        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export-document.filter.template"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="template">
            @for (t of templates; track t) {
              <mat-option value="{{t.id}}">
                <sc-dictionary-label [dictionaryKey]="t.dictionaryKey"></sc-dictionary-label>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <sc-content-spacer></sc-content-spacer>

        <sc-button dictionaryKey="tmc-visit.common.action.show" (click)="updateList()" [disabled]="isUpdateListDisabled()" mat-stroked-button></sc-button>

        <sc-content-spacer></sc-content-spacer>

        <sc-button dictionaryKey="tmc-visit.common.action.export" (click)="createExcel()" [disabled]="isCreateDisabled()" primary></sc-button>

      </sc-flex>
    </form>
  </div>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex-fitting-content vertical>
    <sc-content-area fitHeight>
      <sc-scroll-pane>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export-document.table.column.title"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let document"> {{document.title}} </td>
          </ng-container>
          <ng-container matColumnDef="documentDate">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export-document.table.column.documentDate"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let document"> {{document.documentDate}} </td>
          </ng-container>
          <ng-container matColumnDef="template">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.list-export-document.table.column.template"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let document"> {{document.template}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let transport; columns: columnsToDisplay"></tr>
        </table>
      </sc-scroll-pane>
    </sc-content-area>
  </sc-flex-fitting-content>

</sc-flex>
